import React, { useContext } from 'react';
import { KFLKeyValue } from '@kamstrup/kamstrup-frontend-library';
import * as DeviceInfo from '../../modules/dialogs/deviceInfo';
import * as Devices from '../../modules/devices';
import { AppKeys } from '../../core/localization';
import FlaggedMsg from '../shared/flaggedMsg';
import { LocaleCtx } from '../../contexts/locale.context';
import Scrim from '../shared/scrim';

interface OwnProps {
  item: DeviceInfo.Item;
  isLoading: boolean;
  onlyBasic?: boolean;
}
type Props = OwnProps;
const DeviceInfoItemDetails: React.FC<Props> = (props) => {
  const { item, isLoading, onlyBasic } = props;
  const { translate } = useContext(LocaleCtx);
  
  const snLabel = Devices.getSNLabel(item);
  const kamstrupId = Devices.getPK(item);
  const serialNumberField = {
    key: translate(AppKeys.Device_Prop_SeriaNumber),
    value: snLabel,
  };
  const kamstrupIdField = {
    key: translate(AppKeys.Device_Prop_KamstrupId),
    value: kamstrupId,
  };
  const numericalIdentityField = {
      key: translate(AppKeys.Device_Prop_NumericalIdentity),
      value: String(item.numericalIdentity),
    };
  const idFields = [serialNumberField]
  snLabel !== kamstrupId && idFields.push(kamstrupIdField);
  item.numericalIdentity && idFields.push(numericalIdentityField);  
  
  const basicFields = [
    {
      key: '',
      orientation: 'stacked' as 'stacked',
      value: '',
    },
    ...idFields,
    {
      key: translate(AppKeys.Device_Prop_DeviceName),
      value: String(item.deviceName),
    },
  ];
  

  let extraFields = [
    {
      key: translate(AppKeys.Device_Prop_ProgramNumber),
      value: String(item.programNumber || '-'),
    },
    {
      key: translate(AppKeys.Device_Prop_ConfigurationNumber),
      value: String(item.configurationNumber || '-'),
    },
    {
      key: translate(AppKeys.Device_Prop_TypeNumber),
      value: String(item.typeNumber || '-'),
    },
    {
      key: translate(AppKeys.Device_Prop_ConsumptionType),
      value: translate(
        Devices.ConsumptionTypeDisplay[item.consumptionType] ||
          AppKeys.Device_Consumption_Unknown
      ),
    },
  ];

  

  const error = translate(item.getInfoCall.errorMsg);
  const showError = error.length > 0;
  const additionalFields =
    onlyBasic ||
    // isLoading ||
    showError
      ? []
      : extraFields;

  const fields = [...basicFields, ...additionalFields];

  return (
    <Scrim
      isActive={!onlyBasic && isLoading}
      label={translate(DeviceInfo.msgFetching)}
    >
      <div className="dv-props-box keyvalue_horizontal_fix">
        <KFLKeyValue keyValuePairs={fields} />
        {showError && <FlaggedMsg label={error} />}
      </div>
    </Scrim>
  );
};

export default DeviceInfoItemDetails;
